<template>
  <div class="cbaas-plate plate-wrap">
    <div class="plate-h">
      <div class="title-bg">
        <div class="title-bg-frame"></div>
        <div class="title-bg-decoration left-top"></div>
        <div class="title-bg-decoration right-top"></div>
        <div class="title-bg-decoration left-bottom"></div>
        <div class="title-bg-decoration right-bottom"></div>
      </div>
      <div class="title">
        <span class="title-icon"></span>
        <span>{{ title }}</span>
        <span class="sub-tit">{{ subTit }}</span>
      </div>
      <div v-if="showMore" class="plate-title-action" @click="event.click(title)">
        {{ linkName || '查看更多' }}
        <span :class="['iconfont', 'icon-right-vector', 'action-icon']"></span>
      </div>
    </div>
    <div class="plate-con">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plate',
  props: {
    title: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: () => {
        return {}
      }
    },
    subTit: {
      type: String,
      default: ''
    },
    linkName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'cbaas-plate',
  (
    --cbaas-plate-background-color: #232d51,
    --cbaas-plate-box-shadow-color: #45c2ff,
    --cbaas-plate-title-bg-start-color: rgba(69, 194, 255, 0.65),
    --cbaas-plate-title-bg-end-color: rgba(69, 194, 255, 0),
    --cbaas-plate-title-border-color: #6eb7d9,
    --cbaas-plate-title-decoration-color: #bdeaff,
    --cbaas-plate-title-color: #fff,
    --cbaas-plate-subtitle-color: #fff,
    --cbaas-plate-title-action-color: #45c2ff
  ),
  (
    --cbaas-plate-background-color: #fff,
    --cbaas-plate-box-shadow-color: transparent,
    --cbaas-plate-title-bg-start-color: transparent,
    --cbaas-plate-title-bg-end-color: transparent,
    --cbaas-plate-title-border-color: transparent,
    --cbaas-plate-title-decoration-color: transparent,
    --cbaas-plate-title-color: #122836,
    --cbaas-plate-subtitle-color: #122836,
    --cbaas-plate-title-action-color: #45c2ff
  )
);
.plate-wrap.cbaas-plate {
  @include adaptation(
    (
      --cbaas-plate-box-shadow: 0px 0px 10px 0px,
      --cbaas-plate-title-height: 28px,
      --cbaas-plate-title-boder-width: 0.5px,
      --cbaas-plate-title-decoration-width: 7px,
      --cbaas-plate-title-decoration-height: 2px,
      --cbaas-plate-title-font-size: 14px,
      --cbaas-plate-title-margin-left: 16px,
      --cbaas-plate-subtitle-font-size: 12px,
      --cbaas-plate-subtitle-margin-left: 6px,
      --cbaas-plate-title-icon-width: 19px,
      --cbaas-plate-title-icon-height: 9px,
      --cbaas-plate-title-icon-margin-right: 8px,
      --cbaas-plate-title-action-fontsize: 12px,
      --cbaas-plate-title-action-margin-right: 16px,
      --cbaas-plate-title-action-icon-fontsize: 16px,
      --cbaas-plate-title-action-icon-margin-left: 3px
    )
  );
  width: 100%;
  height: 100%;
  background-color: var(--cbaas-plate-background-color);
  box-shadow: var(--cbaas-plate-box-shadow) var(--cbaas-plate-box-shadow-color) inset;

  .plate-h {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: var(--cbaas-plate-title-height);

    .title-bg {
      position: absolute;
      width: 100%;
      height: var(--cbaas-plate-title-height);
      background: linear-gradient(
        90deg,
        var(--cbaas-plate-title-bg-start-color) 0.32%,
        var(--cbaas-plate-title-bg-end-color) 62.21%
      );
      opacity: 0.5;

      .title-bg-frame {
        width: 100%;
        height: 100%;
        border-top: var(--cbaas-plate-title-boder-width) solid var(--cbaas-plate-title-border-color);
        border-bottom: var(--cbaas-plate-title-boder-width) solid
          var(--cbaas-plate-title-border-color);
      }

      .title-bg-decoration {
        width: var(--cbaas-plate-title-decoration-width);
        height: var(--cbaas-plate-title-decoration-height);
        flex-shrink: 0;
        background: var(--cbaas-plate-title-decoration-color);
        position: absolute;
        z-index: 2;
      }

      .left-top {
        left: 0;
        top: 0;
      }

      .right-top {
        right: 0;
        top: 0;
      }

      .left-bottom {
        left: 0;
        bottom: 0;
      }

      .right-bottom {
        right: 0;
        bottom: 0;
      }
    }

    .title {
      color: var(--cbaas-plate-title-color);
      font-size: var(--cbaas-plate-title-font-size);
      margin-left: var(--cbaas-plate-title-margin-left);
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      z-index: 2;

      .title-icon {
        display: inline-block;
        width: var(--cbaas-plate-title-icon-width);
        height: var(--cbaas-plate-title-icon-height);
        flex-shrink: 0;
        background-image: url('~@/assets/images/components/plate/plate-title-icon.png');
        background-size: 100% 100%;
        margin-right: var(--cbaas-plate-title-icon-margin-right);
      }

      .sub-tit {
        color: var(--cbaas-plate-subtitle-color);
        font-size: var(--cbaas-plate-subtitle-font-size);
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: var(--cbaas-plate-subtitle-margin-left);
      }
    }

    .plate-title-action {
      color: var(--cbaas-plate-title-action-color);
      font-size: var(--cbaas-plate-title-action-fontsize);
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-right: var(--cbaas-plate-title-action-margin-right);
      display: flex;
      align-items: center;
      cursor: pointer;
      z-index: 2;

      .action-icon {
        font-size: var(--cbaas-plate-title-action-icon-fontsize);
        margin-left: var(--cbaas-plate-title-action-icon-margin-left);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .plate-con {
    height: calc(100% - var(--cbaas-plate-title-height));
  }
}
</style>
